import { Injectable } from "@angular/core";
import { PersistedUser, User } from "app/user";
import { AuthVerificationApiModel } from "./auth.apimodel";

/** Converts verified authentication API data into application user models. */
@Injectable({ providedIn: "root" })
export class AuthAdapter {
  /**
   * Maps and validates the backend verification response.
   * @param apiModel The response returned by the verification endpoint.
   * @param sessionId The session id that was verified, as it is not part of the response body.
   * @returns The live and persisted user representations.
   * @throws Error when the response payload is malformed. A `false` verdict is valid and not thrown.
   */
  public toUser(
    apiModel: AuthVerificationApiModel,
    sessionId: string
  ): { user: User; persistedUser: PersistedUser } {
    if (typeof apiModel.authenticated !== "boolean") {
      throw new TypeError("Authentication verification response is malformed");
    }

    const user: User = { authenticated: apiModel.authenticated, sessionId };
    const persistedUser = new PersistedUser();
    persistedUser.sessionId = sessionId;
    return { user, persistedUser };
  }
}
